export default __webpack_public_path__ + "static/media/img_logo_wheel.6c42e40a.svg";